var map = {
	"./51_cat.mp3": "8c7f",
	"./52_mouse.mp3": "9bcc",
	"./53_fish.mp3": "931f",
	"./M_Brilliant.mp3": "770b",
	"./M_Excellent.mp3": "6071",
	"./M_Fantastic.mp3": "b307",
	"./M_Great.mp3": "9cbd",
	"./M_Perfect.mp3": "a604",
	"./M_Think again.mp3": "cdb7",
	"./M_Try again.mp3": "7e33",
	"./M_Very good.mp3": "9606",
	"./M_Well done.mp3": "fe08",
	"./M_Work harder.mp3": "6b23",
	"./click.mp3": "bf5d",
	"./false.mp3": "4598",
	"./true.mp3": "7fd4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d60d";